import { Modal, Flex, message } from "antd";
import { CustomTitle } from "../../components";
import phoneAi from "../../assets/images/Aiphone.svg";
import phoneWhite from "../../assets/images/AiphoneWhite.svg";
import { getCallTranscript } from "../../api's/shipment";
import { useEffect, useState } from "react";
import { useSpin } from "../../components/SpinContext";
import ToggleSwitch from "../../components/ToggleSwitch";
export const formatToCDT = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);

  const options = {
    timeZone: "America/Chicago",
    year: "2-digit",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short",
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const formattedParts = formatter.formatToParts(date);
  const getPart = (type) =>
    formattedParts.find((p) => p.type === type)?.value || "";
  const finalString = `${getPart("month")}/${getPart("day")}/${getPart(
    "year"
  )} at ${getPart("hour")}:${getPart("minute")} ${getPart(
    "dayPeriod"
  )} ${getPart("timeZoneName")}`;

  return finalString;
};
const AiCallTranscriptModal = ({
  open,
  onClose,
  alert,
  token,
  shipment,
  unauthorize,
}) => {
  const [transcriptData, setTranscriptData] = useState(null);
  const { showSpin, hideSpin } = useSpin();
   const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (!alert?.id) return;
    showSpin();
    getCallTranscript(token, alert.id,!isChecked?'English':shipment?.tp_primary_contact?.preferred_language)
      .then((res) => {
        const data = res?.data || null;
        if (data?.data?.is_success) {
          setTranscriptData(data.data.data);
        } else {
          message.error(data?.data?.message);
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  }, [alert, token,isChecked]);

 
  // Function to handle the toggle action
  const handleToggle = (e) => {
    setIsChecked(e.target.checked);
    const val = e.target.checked;
    // fetchAllUsers(val);
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={768}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            src={phoneAi}
            alt="AI Icon"
            style={{ width: "20px", height: "20px" }}
          />
          <CustomTitle
            text="AI call transcript"
            fontSize="20px"
            lineHeight="28px"
            fontWeight="700"
            marginBottom="0px"
          />
        </div>
      }
    >
      <p
        style={{
          fontSize: "12px",
          lineHeight: "20px",
          color: "black",
          marginBottom: "8px",
        }}
      >
        <span style={{ fontWeight: 600 }}>Summary:</span>{" "}
        {transcriptData?.summary || "No summary provided."}
      </p>

      <CustomTitle
        text={`Message is a translation to recipient’s preferred language of ${
          transcriptData?.company_courier_preferred_language || "English(US)"
        }.`}
        fontSize="12px"
        lineHeight="20px"
        fontWeight="400"
        marginBottom="16px"
      />

      {/* Chat container */}
      <div
        className="chat-scroll-container"
        style={{
          background: "#E2E2E2",
          padding: "16px 35px 16px 16px",
          maxHeight: "400px",
          overflowY: "auto",
          overflowX: "hidden",
          marginBottom: "16px",
        }}
      >
        {(transcriptData?.transcript || []).map((msg, index) => {
          const type =
            msg.sender.toLowerCase() === "agent" ? "outgoing" : "incoming";

          return (
            <Flex
              key={index}
              justify={type === "outgoing" ? "flex-end" : "flex-start"}
              style={{ marginBottom: "12px" }}
            >
              <div
                className={`chat-bubble ${type}`}
                style={{
                  background: type === "outgoing" ? "#266EF1" : "#fff",
                  color: type === "outgoing" ? "#fff" : "#000",
                  borderRadius: "12px",
                  padding: "10px 14px",
                  maxWidth: "65%",
                  boxSizing: "border-box",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  position: "relative",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  fontSize: "12px",
                  fontWeight: 400,
                }}
              >
                {msg.text}
                {type === "outgoing" && (
                  <img
                    alt="msgIcon"
                    src={phoneWhite}
                    style={{
                      background: "#266EF1",
                      borderRadius: "50px",
                      padding: "5px",
                      position: "absolute",
                      right: "-31px",
                      bottom: "6px",
                      color: "#005BFF",
                      fontSize: "14px",
                    }}
                  />
                )}
              </div>
            </Flex>
          );
        })}
      </div>

      <Flex justify="space-between">
        <span style={{ fontWeight: 400, fontSize: "12px", color: "#5E5E5E" }}>
          {formatToCDT(transcriptData?.timestamp) || "Start time not available"}
        </span>
        <span style={{ fontWeight: 400, fontSize: "12px", color: "#5E5E5E" }}>
          Call duration: {transcriptData?.call_duration || "N/A"}
        </span>
      </Flex>

      <Flex style={{ alignItems: "center", gap: "8px", marginTop: "16px", marginLeft:'-4px' }}>
        <ToggleSwitch label="" checked={isChecked} onChange={handleToggle} />
        <CustomTitle
          text={`Show in your preferred language: ${transcriptData?.company_user_preferred_language || 'English(US)' } `}
          fontSize="12px"
          lineHeight="16px"
          fontWeight="600"
          marginBottom="0"
        />
      </Flex>
    </Modal>
  );
};

export default AiCallTranscriptModal;
